// DS1.13
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { Url } from '@wix/da-url';
import s from './Loader.scss';
const Loader = ({ size , state ='loading' , className  })=>{
    const getImagePath = (state)=>({
            loading: 'loading/llama-med.gif',
            holiday: 'eclipse/promos/holiday-llama1-red-nosex1.gif',
            static: 'loading/llama-static.gif',
            disabled: 'loading/llama-disabled.png',
            popcorn: 'loading/llama-popcorn.gif',
            eating: 'loading/llama-eating.gif',
            spitting: 'loading/llama-spitting.gif'
        })[state];
    const holiday_2022 = useFlag('holiday_2022');
    const stateValue = state === 'loading' && holiday_2022 ? 'holiday' : state;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], s[stateValue], className)
    }, /*#__PURE__*/ React.createElement("img", {
        src: Url.staticCDNLink(getImagePath(stateValue)),
        alt: "",
        className: s['llama']
    }));
};
Loader.displayName = 'Loader';
export default Loader;
